/** Deep link into the Telegram Mini App (same path the TMA gate uses). */
export const BOT_APP_URL = 'https://t.me/Asia_wallet_bot/app';

/** Public support chat. */
export const SUPPORT_URL = 'https://t.me/asiawallet_support';
